import * as React from 'react'
// libs
import { useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'
// components
import SearchFilter from '../SearchFilter'
import { HoverablePopover, LoaderWithOverlay, Scrollbar } from 'components/UI'
// constants
import { Forms } from 'constants/index'
// view components
import { LinkedItemContainer } from 'containers/LinkedItems'
// context
import { GlobalSearchAPIContext } from 'containers/GlobalSearch/layers/API'
// views
import { FilterIcon, FilterWrapper, InnerWrapper, SearchHelperText, ShowMoreButton } from '../../views'

interface IIncomingProps {
  closeSearch: () => void
}

const SearchResults: React.FunctionComponent<IIncomingProps> = ({ closeSearch }) => {
  const { handleShowMore, isLoading, networkStatus, searchResults, shouldShowButton } =
    React.useContext(GlobalSearchAPIContext)

  const { searchString = '' } = useSelector((state) => ({
    searchString: formValueSelector(Forms.GLOBAL_SEARCH_FORM)(state, 'search')
  }))

  return (
    <>
      <InnerWrapper>
        <FilterWrapper>
          <FilterIcon />
          <HoverablePopover
            trigger={<div>Filter</div>}
            triggerMouseEnter={null}
            PaperProps={{
              style: {
                background: 'none',
                padding: 0
              }
            }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}>
            <SearchFilter />
          </HoverablePopover>
        </FilterWrapper>

        {searchString.length < 3 && (
          <SearchHelperText>
            {`Type ${3 - searchString.length} more character${searchString.length < 2 ? 's' : ''}`}
          </SearchHelperText>
        )}

        <Scrollbar>
          {networkStatus === 2 && isLoading ? (
            <LoaderWithOverlay height={'100%'} isLoading={isLoading} />
          ) : (
            searchResults.map((entity) => {
              return (
                <LinkedItemContainer key={entity.id} source={entity} isGlobalSearch handleCloseSearch={closeSearch} />
              )
            })
          )}

          {networkStatus === 3 && isLoading && <LoaderWithOverlay height={'unset'} isLoading={isLoading} />}
          {!isLoading && shouldShowButton && (
            <ShowMoreButton id={'content'}>
              <span onClick={handleShowMore}>Show more results...</span>
            </ShowMoreButton>
          )}
        </Scrollbar>
      </InnerWrapper>
    </>
  )
}

export default SearchResults
